import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import partnerService from 'api/partner.service';
import { get } from 'lodash';
import { displayAppLoading } from 'reducers/app/app.reducer';

interface ISetState {
  dataList?: Customer;
  isLoading?: boolean;
}

interface IQueryError {
  message: string;
}

export interface PartnerState {
  dataList?: any;
  isLoading: boolean;
  errors?: string[];
  customers: any;
}

const initialState: PartnerState = {
  isLoading: false,
  errors: null,
  dataList: [],
  customers: [],
};

const slice = createSlice({
  name: 'partners',
  initialState: initialState,
  reducers: {
    setState(state: PartnerState, { payload }: PayloadAction<ISetState>) {
      state.isLoading = payload.isLoading;
    },
    onFetchPartnersSuccess(
      state: PartnerState,
      { payload }: PayloadAction<Customer[]>
    ) {
      state.dataList = payload;
    },
  },
});

export const { setState, onFetchPartnersSuccess } = slice.actions;

export default slice.reducer;

export const fetchPartners = (params) => async (dispatch) => {
  try {
    const response = await partnerService.find(params);
    const transformedResponseData = get(response.data, 'dataList', []);
    dispatch(onFetchPartnersSuccess(transformedResponseData));
  } catch (err) {
    console.error('Error', err);
  } finally {
    dispatch(displayAppLoading(false));
  }
};
